import React from 'react';
import { useDispatch } from 'react-redux';
import useRTK from '../../../hooks/useRTK';
import { useActivateSectionMutation, useDeactivateSectionMutation, useRemoveSectionMutation } from '../../../api/students/instituteProgramsAPI';
import { setSections } from '../../../states/features/students/instituteProgramsSlice.js';
import { CircularProgress, IconButton, Switch, Tooltip } from '@mui/material';
import { colors } from '../../../assets/utils/constants';
import { Delete } from '@mui/icons-material';

const SectionsActions = ({ section }) => {
    // ############ CONST ################
    const RTK = useRTK();
    const dispatch = useDispatch();

    // ############ RTK #################
    const [
        activateAction,
        {
            isLoading: activateLoading,
            isSuccess: activateSuccess,
            isError: activateIsError,
            error: activateError,
            data: activateData,
        },
    ] = useActivateSectionMutation();
    const [
        deactivateAction,
        {
            isLoading: deactivateLoading,
            isSuccess: deactivateSuccess,
            isError: deactivateIsError,
            error: deactivateError,
            data: deactivateData,
        },
    ] = useDeactivateSectionMutation();
    const [
        removeSection,
        {
            isLoading: removeLoading,
            isSuccess: removeSuccess,
            isError: removeIsError,
            error: removeError,
            data: removeData,
        },
    ] = useRemoveSectionMutation();
    // ############# useEffect ##################
    // => Action res
    const rtkActions = (data) => {
        dispatch(setSections(data));
    };
    // => Activate
    RTK.useRTKResponse(
        activateSuccess,
        activateIsError,
        activateError,
        activateData,
        rtkActions,
    );
    // => Deactivate res
    RTK.useRTKResponse(
        deactivateSuccess,
        deactivateIsError,
        deactivateError,
        deactivateData,
        rtkActions,
    );
    // => Remove
    RTK.useRTKResponse(
        removeSuccess,
        removeIsError,
        removeError,
        removeData,
        rtkActions,
    );

    return (
        <>
            <Tooltip
                title={
                    section.status ? 'Deactivate section' : 'Activate section'
                }
                arrow
            >
                <IconButton
                    size="small"
                    disabled={
                        activateLoading || deactivateLoading ? true : false
                    }
                    onClick={() =>
                        section.status
                            ? deactivateAction(section.id)
                            : activateAction(section.id)
                    }
                >
                    {activateLoading || deactivateLoading ? (
                        <>
                            <CircularProgress
                                size={20}
                                color="primary"
                                sx={{
                                    mx: 1.2,
                                    my: 0.3,
                                }}
                            />
                        </>
                    ) : (
                        <Switch
                            size="small"
                            color={section.status ? 'success' : 'error'}
                            checked={section.status ? true : false}
                        />
                    )}
                </IconButton>
            </Tooltip>
            <Tooltip title="Remove section" arrow>
                <IconButton
                    size="small"
                    sx={{
                        background: `linear-gradient(180deg, ${colors.bgColor3}, ${colors.bgColor4})`,
                    }}
                    onClick={() => removeSection(section.id)}
                    disabled={removeLoading ? true : false}
                >
                    {removeLoading ? (
                        <CircularProgress
                            size={15}
                            color="primary"
                            sx={{
                                mx: 0.5,
                            }}
                        />
                    ) : (
                        <Delete
                            sx={{
                                fontSize: 16,
                                mx: 0.5,
                            }}
                            color="error"
                        />
                    )}
                </IconButton>
            </Tooltip>
        </>
    );
};

export default SectionsActions;
